
import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import axios from "../axios/axios";
import { Link, useParams } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";

export default function AvantPostuler(){

    const { idOffre } = useParams();

    const [offreEmploi, setOffreEmploi] = useState({});
    const [chargement, setChargement] = useState(false);
    
    useEffect(() => {
        Cookies.set('idoffre', idOffre);
        getOffreEmplPourPostuler();
    }, []); 
    
    const getOffreEmplPourPostuler = () => {
        setChargement(true)
        axios
        .get(`/getOffrePourPostuler/${idOffre}`, {
            headers: {
            Accept: "application/json",
            },
        })
        .then((response) => { 
            setOffreEmploi(response.data.offeremp);
            setChargement(false)
        }).catch((error) => {
            console.log(error);
        });
    
    }

    return(
        <>
            { chargement == true ? 
            
            <div className="container card text-center mt-5">
              <h4>Chargement .... </h4>
            </div>

            :
            <div className="container" style={{marginTop:'20px', paddingTop:10}}>
                <div className="row bg-light">
                    <div className="col-sm-12">
                        <center> 
                            <h4>
                                <span style={{fontWeight: "900"}}
                                    dangerouslySetInnerHTML={{
                                    __html: offreEmploi.libelle,
                                }}
                                ></span>




                            </h4>
                            <h5 style={{padding: "10px"}}> Si vous avez déjà un compte sur RIMTIC 
                                <Link to={`${process.env.PUBLIC_URL}/consulter-voter-cv-pour-postuler`} style={{fontWeight: '900', color: 'red', textDecoration:'none'}}> cliquer ici </Link> 
                                pour se connecter et postuler. 
                            </h5>
                            <br />
                            <h5 style={{padding: "10px"}}>Si vous n'avez pas encore un compte, 
                                <Link to={`${process.env.PUBLIC_URL}/inscrire`} style={{fontWeight: '900', color: "red", textDecoration:'none'}}> cliquez ici </Link> pour s'inscrire.
                            </h5>
                        </center>
                    </div>
                </div>
            </div>
            }
        </>
    )
}